export const USER_INFORMATION = 'USER_INFORMATION';
export const USER_UF_SELECTED = 'USER_UF_SELECTED';
export const USER_SYSTEM = 'USER_SYSTEM';
export const USER_UF = 'USER_UF';
export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const LOADING = 'LOADING';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const REGIONAL_ALVO = 'REGIONAL_ALVO';
export const IS_ADMIN = 'IS_ADMIN';
